module.exports = __webpack_public_path__ + "assets/corriente.f2550b072ba9597d5ec40d584e09eb07.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/corriente.png
// module id = 888
// module chunks = 0